import { IProject, IProjectMin } from '@/lib/interfaces';

export function projectMinimize(project: IProject): IProjectMin {
  return {
    _id: project._id,
    title: project.title,
    key: project.key,
  };
}
